import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchBenefitPlanComponents, fetchBnftPlanCompProvFact } from "../../utils/apiUtils";
import { useEffect, useState, useCallback } from "react";
import { useInView } from 'react-intersection-observer'
import SharedTable from "./SharedTable";
import debounce from 'lodash.debounce';
import { queryClient } from "../../App";

const limit = 10

const BenefitPlanComponents = ({ }) => {

    const [searchValue, setSearchValue] = useState('');
    const [decouncedSearchValue, setDecouncedSearchValue] = useState('')
    const [showMoreColumns, setShowMoreColumns] = useState(false);
    const { ref, inView } = useInView()

    const queryKey = ['components', limit, decouncedSearchValue];
    const {
        data,
        error,
        fetchNextPage,
        hasNextPage,
        isLoading,
        isFetching,
        isFetchingNextPage,
        status,
        refetch,

    } = useInfiniteQuery({
        queryKey,
        queryFn: async ({ pageParam }) => {
            let params = pageParam || {}


            if (decouncedSearchValue) {
                params.benefitPlanCompName = decouncedSearchValue
            }

            return await fetchBenefitPlanComponents(params)

        },

        select: (data) => {
            //   console.log({ data });
            return {
                count: data.pages?.[0]?.count, rows: data.pages.map((page) => page.rows.map(row => ({
                    ...row
                }))).flatMap((x) => x)
            };
        },
        initialPageParam: 0,
        placeholderData: (previousData, previousQuery) => previousData,
        getNextPageParam: (lastPage, pages) => {
            const hasMore = lastPage.rows?.length === limit

            if (!hasMore) return undefined
            return {
                offset: pages.reduce((accum, page) => {
                    return accum + page.rows.length;
                }, 0),
            };
        },
        staleTime: 0,
        enabled: true
    });

    useEffect(() => {
        if (inView) {
            fetchNextPage()
        }
    }, [inView])

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    let columns = ['benefitPlanCompName', 'benefitPlanCompDesc',];

    if (showMoreColumns) {
        columns = [
            'benefitPlanCompKey', 'bnftPlanCompHistFactKey',
            ...columns,

        ];
    }

    const onDetailHandler = async ({ bnftPlanCompHistFactKey }) => {
        const provisions = await fetchBnftPlanCompProvFact({ bnftPlanCompHistFactKey, limit: 100 })
        return { provisions }
    }

    return (
        <div className={'container '} style={{ padding: '1rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                <div>
                    <p style={{ fontSize: '1.2rem', fontWeight: '600' }}>Components  ( {data?.count || 0} )</p>
                    <p className="sub-title">Benefit Plan Compoennts</p>
                </div>



            </div>


            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', paddingRight: '1rem' }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', justifyContent: 'start', width: '100%', padding: '1rem 0rem' }}>




                    <input
                        style={{ fontSize: '1rem', minWidth: '250px', padding: '1rem', borderRadius: '.4rem', border: '1px solid var(--lighterGrey)', outline: 'none' }}
                        type="text"
                        id={'search'}
                        placeholder="search..."
                        // list="items"
                        autoComplete="off"
                        // onFocus={() => setCurrentPage(0)}
                        onChange={(e) => {

                            setSearchValue(e.target.value);
                            debouncedChangeHandler(e);
                        }}
                        value={searchValue}
                    />

                </div>


            </div>


            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0rem 1rem 1rem 0rem" }}>
                <p
                    style={{ cursor: "pointer", color: "var(--red)" }}
                    onClick={() => {
                        queryClient.resetQueries({ queryKey });


                        setDecouncedSearchValue("");
                        setSearchValue("");

                    }}
                >
                    Clear filters
                </p>
                <p style={{ cursor: "pointer", color: "var(--green)" }} onClick={() => setShowMoreColumns(!showMoreColumns)}>
                    {showMoreColumns ? "Less Columns" : "More Columns"}
                </p>

            </div>


            {status === 'loading' ? (
                <p>Loading...</p>
            ) : status === 'error' ? (
                <span>Error: {error.message}</span>
            ) : (
                <>
                    <SharedTable
                        type={'components'}
                        columns={columns}
                        items={data?.rows}
                        activeDraftId={null}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        fetchNextPage={fetchNextPage}
                        isFetching={isFetching}
                        isLoading={isLoading}
                        onDetailHandler={onDetailHandler}
                        ref={ref}
                    />

                </>)}

        </div >
    )
}

export default BenefitPlanComponents